<template>
  <div class="logo-box" :class="{ 'logo-box--minimized': minimized }">
    <b-img :src="$config.images.tinyLogo" class="logo-box__logo" />
    <span
      v-show="!minimized"
      class="logo-box__title"
      v-html="$lang.project_title"
    />
  </div>
</template>

<script>
export default {
  props: {
    minimized: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
